import api from 'api'

export type LinkVndlyCandidateParams = {
  workerId: number
  vndlyInstanceId: number
  candidateUniqueId: string
}

export type LinkVndlyCandidateResponse = {
  candidateId: number
}

export const linkVndlyCandidate = async (
  params: LinkVndlyCandidateParams
): Promise<LinkVndlyCandidateResponse> => {
  const result = await api.post<LinkVndlyCandidateResponse>(
    '/admin/vndly/candidates/link',
    params
  )
  return result.data
}
